import { DISSECTED_ERROR, HANDLED_APPLICATION_ERROR } from '../constants/error-codes'
import { DissectedError } from '../DissectedError'
import { HandledApplicationError } from '../HandledApplicationError'

/**
 * Deserializes a JSON string into a HandledApplicationError or DissectedError object.
 *
 * @param jsonOfError - The JSON string representation of an error
 * @returns The deserialized error object or the original string if deserialization fails
 */
export const deserializeError = (jsonOfError: string) => {
    try {
        const errorObject = JSON.parse(jsonOfError)

        const message = errorObject.message ?? jsonOfError
        // Remove the message property to avoid duplication in the data
        delete errorObject.message

        if (errorObject.code === HANDLED_APPLICATION_ERROR) {
            return new HandledApplicationError(message, { ...errorObject })
        }

        if (errorObject.code === DISSECTED_ERROR) {
            return new DissectedError(message, { ...errorObject })
        }

        return jsonOfError
    } catch (_) {
        // Return the original string if JSON parsing fails
        return jsonOfError
    }
}
